import getEnvironment from 'app/environment'
import * as Application from 'expo-application'
import { FreshchatScreenProps } from 'home/stack/types'
import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import FreshChat from 'react-freshchat'
import { ActivityIndicator, View } from 'react-native'
import { useUser } from 'users/queries/detail'

import { useUpdateUserRestoreId } from 'users/queries/update_restore_id'

export function FreshchatScreen({ navigation }: FreshchatScreenProps) {
  const { FRESHCHAT_HELPER, FRESHCHAT_MANAGER } = getEnvironment()
  const widgetRef = useRef<FreshChat | null>(null)
  const { data: user } = useUser()
  const updateUserRestoreIdMutation = useUpdateUserRestoreId()
  const userRole =
    user?.role === 'helper'
      ? 'Helper'
      : user?.role === 'manager'
      ? 'Manager'
      : user?.role === 'observer'
      ? 'Observer'
      : user?.role === 'admin'
      ? 'Admin'
      : 'Uknown Role'
  const appVersion = Application.nativeApplicationVersion
  const userProperties = useMemo(() => {
    return {
      firstName: user?.firstName,
      lastName: user?.lastName,
      phone: user?.phoneNumber,
      cf_next_id: user?.id,
      cf_home_store_id: user?.homeStoreId?.toString(),
      cf_role: userRole,
      cf_company: user?.company,
      cf_next_connect: user?.nextConnect,
      cf_app_version: appVersion,
    }
  }, [
    appVersion,
    user?.company,
    user?.firstName,
    user?.homeStoreId,
    user?.id,
    user?.lastName,
    user?.nextConnect,
    user?.phoneNumber,
    userRole,
  ])

  const FreshchatWidget = useCallback(
    () => (
      <FreshChat
        token={user?.role === 'helper' ? FRESHCHAT_HELPER : FRESHCHAT_MANAGER}
        externalId={user?.id}
        restoreId={user?.restoreId ? user?.restoreId : null}
        open={true}
        config={{
          headerProperty: { hideChatButton: true },
          fullscreen: true,
        }}
        onInit={(widget: any) => {
          widgetRef.current = widget

          widget.on('widget:closed', function (resp: any) {
            navigation.goBack()
          })
          widget.user.get(function (resp: any) {
            const status = resp && resp.status
            if (status !== 200) {
              widget.user.setProperties(userProperties)
            } else {
              widget.user.update(userProperties)
            }
          })

          widget.on('user:created', function (resp: any) {
            const status = resp && resp.status,
              data = resp && resp.data
            if (status === 200) {
              if (data.restoreId) {
                updateUserRestoreIdMutation
                  .mutateAsync({ restoreId: data.restoreId })
                  .catch(e => console.log(e))
              }
            }
          })
        }}
      />
    ),
    [
      FRESHCHAT_HELPER,
      FRESHCHAT_MANAGER,
      navigation,
      updateUserRestoreIdMutation,
      user?.id,
      user?.restoreId,
      user?.role,
      userProperties,
    ]
  )

  useEffect(() => {
    return () => {
      if (widgetRef.current) {
        widgetRef.current.destroy()
      }
    }
  }, [])

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ActivityIndicator />
      <FreshchatWidget />
    </View>
  )
}
